import { render, staticRenderFns } from "./FileInputBasic.vue?vue&type=template&id=5776767a&"
import script from "./FileInputBasic.vue?vue&type=script&lang=js&"
export * from "./FileInputBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports